import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export const CONTACT_EMAIL = "info@yallahero.com";
const inputCls = "w-full h-11 px-4 bg-white border border-[#E5DCCB] rounded-sm text-sm focus:outline-none focus:border-[#8B3A2B]";
const empty = { name: "", email: "", school: "", phone: "", message: "" };

export const ContactDialog = ({ open, onOpenChange }) => {
  const { t, isRtl } = useLang();
  const c = t.contact;
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success(c.sent);
      setForm(empty);
      onOpenChange(false);
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" && err?.response?.status === 429 ? d : c.error);
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent dir={isRtl ? "rtl" : "ltr"} className="max-w-lg max-h-[92vh] overflow-y-auto" data-testid="contact-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-start">{c.title}</DialogTitle>
          <DialogDescription className="text-start">{c.sub}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3" data-testid="contact-form">
          <input required minLength={2} placeholder={c.name} aria-label={c.name} className={inputCls} value={form.name} onChange={set("name")} data-testid="contact-name" />
          <input required type="email" dir="ltr" placeholder={c.email} aria-label={c.email} className={inputCls} value={form.email} onChange={set("email")} data-testid="contact-email" />
          <input placeholder={c.school} aria-label={c.school} className={inputCls} value={form.school} onChange={set("school")} data-testid="contact-school" />
          <input dir="ltr" placeholder={c.phone} aria-label={c.phone} className={inputCls} value={form.phone} onChange={set("phone")} data-testid="contact-phone" />
          <textarea required minLength={5} rows={4} placeholder={c.message} aria-label={c.message} className={`${inputCls} h-auto py-3`} value={form.message} onChange={set("message")} data-testid="contact-message" />
          <button disabled={busy} className="w-full h-11 rounded-full bg-[#1C1917] text-[#FAF7F2] font-semibold hover:bg-[#8B3A2B] transition-colors disabled:opacity-50" data-testid="contact-submit">
            {busy ? c.sending : c.send}
          </button>
          <p className="text-sm text-stone-600 text-center">{c.orEmail} <a href={`mailto:${CONTACT_EMAIL}`} dir="ltr" className="font-semibold text-[#8B3A2B] hover:underline" data-testid="contact-mailto">{CONTACT_EMAIL}</a></p>
        </form>
      </DialogContent>
    </Dialog>
  );
};
